module.exports = __webpack_public_path__ + "dd8990aedf7b2cc6108e8bc0aae16da5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/cart.svg
// module id = 83
// module chunks = 0